import { vehicleSubcategoriesSlice } from "./vehicleSubcategoriesSlice";
import * as actions from "./vehicleSubcategoriesActions";
import * as selectors from "./vehicleSubcategoriesSelectors";

export { actions };
export { selectors };
export default vehicleSubcategoriesSlice.reducer;
